<template>
	<div class="container">
		<section class="content checkout-content wp_AllPageMarginTop">
			<div class="vendor-listing-section product-variant-listing">
				<div class="product-display product-display-head">
					<div class="product-image-a" v-if="productData && productData.product_details">
						<img :src="productData.product_details.image_URL_1"
											alt="Product Image"
											data-test="productVarientListingImg1"
											id="productVarientListingImg1"
						>
					</div>
					<div class="product-details">
						<p v-if="productData && productData.product_name"
									data-test="productVarientListingPdtName"
									id="productVarientListingPdtName">
							{{productData.product_name}}</p>
						<!--<div>Description</div>-->
						<div v-if="productData && productData.review && productData.review.averageRating"
											data-test="productVarientListingPdtRating"
											id="productVarientListingPdtRating">
							{{productData.review.averageRating}}
						</div>
					</div>
				</div>
				<div
					class="vendor-listing-wrapper-phone"
					v-for="(product,index) in getSelectedWpVariantProducts"
					:key="index"
				>
					<div class="vendor-listing-a-wrapper">
						<div
							class="vendor-listing-a-item"
							v-for="(vendor, index) in product.vendor_product_inventories"
							:key="index"
						>
							<div class="top">
								<div class="price-a">
									<p :data-test="'ProductVarientListingPara-'+index"
												:id="'ProductVarientListingPara-'+index">
										{{(vendor.promotional_prices &&
										vendor.promotional_prices.length > 0)?
										vendor.promotional_prices[0].promotion_applied_price:
										vendor.price | currencyConversion
										}}
									</p>
								</div>
								<div class="seller-details-a">
                  <span v-if="vendor && vendor.vendor_name"
																								:data-test="'ProductVarientListingSpan-'+index"
																								:id="'ProductVarientListingSpan-'+index">
                    {{vendor.vendor_name}}
                  </span>
								</div>
							</div>
							<div class="bottom">
								<div class="delivery-a">
									<p :data-test="'ProductVarientListingDeliveryCharge-'+index"
												:id="'ProductVarientListingDeliveryCharge-'+index">
										Charge:
										<b :data-test="'ProductVarientListingDeliveryFee-'+index"
													:id="'ProductVarientListingDeliveryFee-'+index">Free</b>
									</p>
									<!--<p>-->
									<!--Arrives between-->
									<!--<b>July 06 - 10</b>-->
									<!--</p>-->
								</div>
								<div class="buying-opt">
									<cart-action
										:is-add-to-cart="true"
										:is-buy-now="false"
										:pdp="true"
										:fav="true"
										:product="product"
										:vendor-id="vendor.vendor_id"
										v-if="vendor.available_stock && vendor.available_stock > 0"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="vendor-listing-wrapper-desktop">
					<table class="table table-hover">
						<thead>
						<tr>
							<th scope="col"
											data-test="ProductVarientListingPdt"
											id="ProductVarientListingPdt">Product</th>
							<th scope="col"
											data-test="ProductVarientListingSeller"
											id="ProductVarientListingSeller">Seller</th>
							<th scope="col"
											data-test="ProductVarientListingDelivery"
											id="ProductVarientListingDelivery">Delivery</th>
							<th scope="col"
											data-test="ProductVarientListingPrice"
											id="ProductVarientListingPrice">Price</th>
							<th scope="col"
											data-test="ProductVarientListingBuying"
											id="ProductVarientListingBuying">Buying options</th>
						</tr>
						</thead>
						<tbody
							v-for="(product,index) in getSelectedWpVariantProducts"
							:key="index"
						>
						<tr
							v-for="(vendor, index) in product.vendor_product_inventories"
							:key="index"
						>
							<th scope="row">
								<div class="product-name-a">
									<div class="product-display">
										<div class="product-image-a">
											<img
												:src="product.product_details.images[0]"
												alt="Product Image"
												:data-test="'ProductVarientListingPdtimg-'+index"
												:id="'ProductVarientListingPdtimg-'+index"
											>
										</div>
										<div
											class="product-details"
											@click.prevent="selectedVariantProduct(product)"
											style="cursor: pointer"
										>
											<p :data-test="'ProductVarientListingPdtName-'+index"
														:id="'ProductVarientListingPdtName-'+index">
												{{product.product_name}}</p>
											<div>
												<span
													v-for="(spec, index) in product.product_specification"
													:key="index"
													:data-test="'ProductVarientListingSpecValue-'+index"
													:id="'ProductVarientListingSpecValue-'+index"
												>
													{{index === 0 ?spec.value:','+spec.value}}
												</span>
											</div>
										</div>
									</div>
								</div>
							</th>
							<td>
								<div class="seller-details-a">
									<span :data-test="'ProductVarientListingVendorName-'+index"
															:id="'ProductVarientListingVendorName-'+index">{{vendor.vendor_name}}</span>
								</div>
							</td>
							<td>
								<div class="delivery-a">
									<p :data-test="'ProductVarientListingCharge2-'+index"
												:id="'ProductVarientListingCharge2-'+index">
										Charge:
										<b :data-test="'ProductVarientListingFree2-'+index"
													:id="'ProductVarientListingFree2-'+index">Free</b>
									</p>
									<!--<p>-->
									<!--Arrives between-->
									<!--<b>July 06 - 10</b>-->
									<!--</p>-->
								</div>
							</td>
							<td>
								<div class="price-a">
									<p :data-test="'ProductVarientListingPrice-a-'+index"
												:id="'ProductVarientListingPrice-a-'+index">
										{{(vendor.promotional_prices &&
										vendor.promotional_prices.length > 0)?
										vendor.promotional_prices[0].promotion_applied_price:
										vendor.price | currencyConversion
										}}
									</p>
								</div>
							</td>
							<td>
								<div class="buying-opt">
									<cart-action
										:is-add-to-cart="true"
										:is-buy-now="false"
										:pdp="true"
										:fav="true"
										:product="product"
										:vendor-id="vendor.vendor_id"
										v-if="vendor.available_stock && vendor.available_stock > 0"
									/>
								</div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import CartAction from '@/components/actions/cart/CartAction'
import { mapGetters } from 'vuex'

export default {
	name: 'product-variant-listing',
	components: {
		CartAction
	},
	computed: {
		...mapGetters('productselected', ['getSelectedWpVariantProducts']),
		productData () {
			if (this.getSelectedWpVariantProducts && this.getSelectedWpVariantProducts.length > 0) {
				return this.getSelectedWpVariantProducts[0]
			}
			return {}
		}
	},
	methods: {
		selectedVariantProduct (product) {
			this.$router.push({
				name: 'ProductDetails',
				path: '/product_description',
				query: {
					productName: product.product_name,
					productId: product.product_id
				}
			})
		}
	}
}
</script>

<style scoped>
</style>
